<div class="card cursor-pointer overlay border border-2 card-bordered shadow search-card-corporate"
[ngbPopover]="popContent" container="body" [placement]="['left', 'right','top']" triggers="mouseenter:mouseleave"
[disablePopover]="!corporate.shortDescription && !corporate.briefDescription"
  popoverClass="popover-custom-width"

  (click)="openDetailsView()">
  <div class="card-body overlay-wrapper text-left p-0 cardImageSection">
    <img class="w-100 rounded" [src]="s3logoUrl" />


    <div class="badge rounded badge-primary co-investing-badge" *ngIf="corporate.isLiveDeal">
      CO-INVESTING
    </div>
    <div class="badge rounded compare-badge badge-dark" *ngIf="openedFrom==='recommended'" (click)="
    hideRecommendedEvent($event)">
      Hide
    </div>



    <div class="mb-0 nameSection">
      <h3 class="fw-bolder text-white fs-1x mb-3 text-truncate">
        {{ corporate.companyName }}
      </h3>

    </div>
  </div>

  <div class="card-footer d-flex align-items-center p-3   w-100 overflow-hidden">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div class="d-flex  align-items-center">


    <span [ngbTooltip]="corporate.sectoralInterests?.join(', ')"
      class="badge  badge-secondary text-dark badge-custom-search-page fs-8 bg-white" style="max-width: 100%;">

      <ng-container *ngIf="corporate?.sectoralInterests?.length">
        <span class="text-truncate"> {{corporate?.sectoralInterests[0]}}</span>

        <span *ngIf="corporate.sectoralInterests.length > 1">&nbsp;(+{{corporate.sectoralInterests.length - 1}})</span>
      </ng-container>

      <ng-container *ngIf="!corporate?.sectoralInterests?.length">
        N/A
      </ng-container>
    </span>
      </div>
      <div *ngIf="connectionObj">
        <span [ngbTooltip]="connectionTooltip">
          <i class="bi bi-patch-check-fill fs-1 text-green header-icons-font-size"></i>
        </span>
      </div>


      <div *ngIf="addedToWishlist" style="width: 25px;">
        <span [ngbTooltip]="'Saved for later'">
          <i class="bi bi-bookmark-fill fs-4 text-primary"></i>
        </span>
      </div>

    </div>

</div>
<ng-template #popContent>
  <div *ngIf="corporate.briefDescription || corporate.shortDescription">
    {{(corporate.briefDescription || corporate.shortDescription || '') | truncate:500 | decodeHtmlString}}
  </div>
</ng-template>
